import React, {useEffect, useState} from "react";
import {
    Alert,
    Button,
    Card,
    Checkbox,
    Col,
    Divider,
    Form,
    Input,
    message,
    Modal,
    Row,
    Select,
    Space,
    Spin,
    Upload
} from "antd";
import {BankDetailDto} from "../../dto/BankDetailDto";
import {InputDropdownParameterDto} from "../../dto/InputDropdownParameterDto";
import {
    ACCOUNT_NAME_VALIDATION,
    ALLOWED_IMAGE_TYPE_EXTENSION,
    ALLOWED_IMAGE_TYPES, ALLOWED_IMAGE_TYPES_TEXT,
    COMMON_DROPDOWN,
    DOCUMENT_TYPES,
    PARAMETER_LIST, PREVIEW_DOC_TYPES
} from "../../util/Constants";
import {DropdownListDto} from "../../dto/DropdownListDto";
import Validation from "../../util/Validation";
import {toNumber} from "lodash";

import customerService from "../../service/customerService";
import ErrorHandler from "../../util/ErrorHandler";
import {
    MSG_ALLOWED_DOCUMENT_TYPES_ERROR,
    MSG_ALLOWED_IMAGE_TYPES_ERROR,
    MSG_FAILED_TO_DELETE_DOCUMENTS_ERROR,
    MSG_FAILED_TO_FETCH_AGREEMENTS_ERROR,
    MSG_FAILED_TO_FETCH_BANK_BRANCH_LIST_ERROR,
    MSG_FAILED_TO_FETCH_BANK_LIST_ERROR, MSG_FAILED_TO_FETCH_DOCUMENTS_ERROR,
    MSG_FAILED_TO_UPLOAD_DOCUMENTS_ERROR
} from "../../util/Messages";
import customerChangeRequestService from "../../service/customerChangeRequestService";
import modal from "antd/es/modal";
import {DownloadOutlined, ExclamationCircleOutlined, PlusOutlined} from "@ant-design/icons";
import documentService from "../../service/documentService";
import {UploadedDocumentDetailDto} from "../../dto/UploadedDocumentDetailDto";
import PreviewModalComp from "../common/preview/PreviewModalComp";

const BANK_ACC_TYPE_PRIMARY = "PRIMARY"
const BANK_ACC_TYPE_SECONDARY = "SECONDARY"

interface BankDetailProps {
    cin: string
}

interface BankDetailWrapperDto {
    primaryUpdated: boolean
    correspondenceUpdated: boolean
    primeryBankDetailDto: BankDetailDto
    correspondenceBankDetailDto: BankDetailDto
    bankDetailDtoList: BankDetailDto[]
    editable: boolean
}

interface DefaultDocDto {
    uid: string
    name: string
    thumbUrl: string
    url: string
    documentTypeId: number
}

const uploadFileSize: number | undefined = process.env.UPLOAD_FILE_SIZE ? toNumber(process.env.UPLOAD_FILE_SIZE) : 4;
const configs = {
    name: 'file',
    multiple: false,
    maxCount: 1
};
const PRIMARY_BANK_CONFIRMATION = "PBCL"
const SECONDARY_BANK_CONFIRMATION = "SBCL"
const BankDetailsChangeRequestComp = (props: BankDetailProps) => {

    const [primaryForm] = Form.useForm();
    const [secondaryForm] = Form.useForm();
    const [isSetSecondaryAccDataFilledAlready, setSecondaryAccDataFilledAlready] = useState(false);
    const [isSetSecondaryAccDataFilledAlreadyTemp, setSecondaryAccDataFilledAlreadyTemp] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [isAbleToEdit, setAbleToEdit] = useState(true);
    const [isPrimaryBankConfirmationChanged, setPrimaryBankConfirmationChanged] = useState(false);
    const [isSecondaryBankConfirmationChanged, setSecondaryBankConfirmationChanged] = useState(false);
    const [bankList, setBankList] = useState<DropdownListDto[]>([]);
    const [branchListPrimary, setBranchListPrimary] = useState<DropdownListDto[]>([]);
    const [branchListSec, setBranchListSecondary] = useState<DropdownListDto[]>([]);
    const [bankDetailList, setBankDetailList] = useState<BankDetailDto[]>([]);
    const [primaryUploadedList, setPrimaryUploadedList] = useState<DefaultDocDto[]>()
    const [secondaryUploaderList, setSecondaryUploadedList] = useState<DefaultDocDto[]>()
    const [jobNumber, setJobNumber] = useState<string>("")
    const [previewOpen, setPreviewOpen] = useState(false);
    const [docURL, setDocURL] = useState('');
    const [docType, setDocType] = useState<PREVIEW_DOC_TYPES>(PREVIEW_DOC_TYPES.IMAGE);
    const [previewTitle, setPreviewTitle] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isEditDisabled, setEditDisabled] = useState<boolean>(true)

    useEffect(() => {
        getBankList()
        getBankDetails()
    }, [])

    const getBankDetails = () => {
        setLoading(true)
        customerChangeRequestService.getCustomerBankDetailList(props.cin).then(res => {

            setFieldValues(res.data.results.bankDetailDtoList)
            setBankDetailList(res.data.results.bankDetailDtoList)
            setAbleToEdit(res.data.results.editable)
            setLoading(false)
        }, (reason) => {
            setLoading(false)

            ErrorHandler.handleError(reason);
        })
    }
    const setFieldValues = (bankDetailList: BankDetailDto[]) => {

        let primaryAcc: BankDetailDto | undefined;
        let secondaryAcc: BankDetailDto | undefined;

        if (bankDetailList.length > 0) {
            primaryAcc = bankDetailList.find(bankDetail => bankDetail.bankAccountType === "PRIMARY");

            if (primaryAcc) {
                getBranchList(primaryAcc.bankId, true)
                setJobNumber(primaryAcc.jobNumber ?? "")
                loadUploadedDocuments(primaryAcc.jobNumber, [PRIMARY_BANK_CONFIRMATION])
                primaryForm.setFieldsValue(
                    {
                        id: primaryAcc.id,
                        accountHolderName: primaryAcc.accountHolderName,
                        accountNo: primaryAcc.accountNo,
                        bankId: toNumber(primaryAcc.bankId),
                        branchId: toNumber(primaryAcc.branchId),
                        recordStatus: primaryAcc.recordStatus
                    }
                )
            }

            if (bankDetailList.length > 1) {
                secondaryAcc = bankDetailList.find(bankDetail => bankDetail.bankAccountType === "SECONDARY");
                if (secondaryAcc) {
                    getBranchList(secondaryAcc.bankId, false)
                    setSecondaryAccDataFilledAlready(true)
                    setSecondaryAccDataFilledAlreadyTemp(true)
                    loadUploadedDocuments(secondaryAcc.jobNumber, [SECONDARY_BANK_CONFIRMATION])
                    secondaryForm.setFieldsValue(
                        {
                            id: secondaryAcc.id,
                            accountHolderName: secondaryAcc.accountHolderName,
                            accountNo: secondaryAcc.accountNo,
                            bankId: toNumber(secondaryAcc.bankId),
                            branchId: toNumber(secondaryAcc.branchId),
                            recordStatus: secondaryAcc.recordStatus
                        }
                    )
                }

            }
        }


    }
    const loadUploadedDocuments = (jobNo: number | undefined, identityDocumentTypeCodeList: string[]) => {
        if (jobNo) {
            setLoading(true)
            documentService.getUploadDocumentListByType(jobNo, identityDocumentTypeCodeList).then(res => {
                if (res.data !== null) {
                    setUploadedDocumentList(res.data.results)
                } else {
                    message.error(MSG_FAILED_TO_FETCH_AGREEMENTS_ERROR).then();
                }
            }, (reason) => {
                ErrorHandler.handleError(reason);
            })
        }

    };
    const [tempPrimaryBankProfDocId, setTempPrimaryBankDocId] = useState(0);
    const [tempSecondaryBankDocId, setTempSecondaryBankDocId] = useState(0);
    const setUploadedDocumentList = (documents: any) => {

        documents.forEach((document: any) => {
            if (document.uploadDocumentDetailDto != null) {
                let uploadDocumentDetailDto: UploadedDocumentDetailDto = document.uploadDocumentDetailDto;
                if (uploadDocumentDetailDto.documentTypeId === DOCUMENT_TYPES.PBCL) {
                    setTempPrimaryBankDocId(uploadDocumentDetailDto.uploadDocumentDetailId)
                } else {
                    setTempSecondaryBankDocId(uploadDocumentDetailDto.uploadDocumentDetailId)
                }
                createUploadedDocuments(uploadDocumentDetailDto, document.documentTypeId)
            }

        })
    };
    const onChangeBank = (selectedBranchId: number) => {
        primaryForm.resetFields(['branchId', 'primaryBankConfirmation', 'accountHolderName', 'accountNo'])
        onRemove(primaryUploadedList && primaryUploadedList.length > 0 ? primaryUploadedList[0].documentTypeId : 0)
        getBranchList(selectedBranchId, true)
    }
    const onChangeBankSec = (selectedBranchId: number) => {
        secondaryForm.resetFields(['branchId', 'secondaryBankConfirmation', 'accountHolderName', 'accountNo'])
        onRemove(secondaryUploaderList && secondaryUploaderList.length > 0 ? secondaryUploaderList[0].documentTypeId : 0)
        getBranchList(selectedBranchId, false)
    }

    const getBankList = () => {
        const inputDropdownParameterDto: InputDropdownParameterDto = {
            dropdownDataSourceId: COMMON_DROPDOWN.BANK_LIST,
            findTextValue: "",
            parameterList: [PARAMETER_LIST.ACTIVE]
        }
        loadCommonDropdownDataList(inputDropdownParameterDto, COMMON_DROPDOWN.BANK_LIST);
    }
    const getBranchList = (selectedBank: number, isPrimaryAcc: boolean) => {
        const inputDropdownParameterDto: InputDropdownParameterDto = {
            dropdownDataSourceId: COMMON_DROPDOWN.BRANCH_LIST,
            findTextValue: "",
            parameterList: [[selectedBank], [PARAMETER_LIST.ACTIVE]]
        }
        customerService.getCommonDropdown(inputDropdownParameterDto).then(res => {
            if (res.data !== null) {
                if (isPrimaryAcc) {
                    setBranchListPrimary(res.data.results.activeItemList)
                } else {
                    setBranchListSecondary(res.data.results.activeItemList)
                }
            } else {
                message.error(MSG_FAILED_TO_FETCH_BANK_BRANCH_LIST_ERROR).then();
            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
        })
    }
    const setType = (type: COMMON_DROPDOWN, result: DropdownListDto[]) => {
        if (type == COMMON_DROPDOWN.BANK_LIST) {
            setBankList(result)
        }
    }
    const loadCommonDropdownDataList = (dropDownParameterDto: InputDropdownParameterDto, type: COMMON_DROPDOWN) => {
        customerService.getCommonDropdown(dropDownParameterDto).then(res => {
            if (res.data !== null) {
                setType(type, res.data.results.activeItemList)
            } else {
                message.error(MSG_FAILED_TO_FETCH_BANK_LIST_ERROR).then();
            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
        })
    }

    const onClickSubmit = () => {
        let bankDetailWrapperDto = {} as BankDetailWrapperDto;
        setLoading(true)
        let primaryAccPromise
        let secondaryAccPromise
        const primaryAccData: BankDetailDto | undefined = bankDetailList.find(bankDetail => bankDetail.bankAccountType === "PRIMARY");
        const secondaryAccData: BankDetailDto | undefined = bankDetailList.find(bankDetail => bankDetail.bankAccountType === "SECONDARY");
        if (validateBothAddressChanges(primaryAccData, secondaryAccData, primaryForm.getFieldsValue(), secondaryForm.getFieldsValue())) {
            primaryAccPromise = primaryForm.validateFields().then(() => {
                if (validateAddressChanges(primaryAccData, primaryForm.getFieldsValue(), true)) {
                    let bankDetailDto: BankDetailDto = primaryForm.getFieldsValue()
                    bankDetailDto.bankAccountType = BANK_ACC_TYPE_PRIMARY
                    bankDetailDto.cin = props.cin
                    bankDetailDto.jobNumber = jobNumber
                    if (primaryUploadedList && primaryUploadedList.length > 0) {
                        if (tempPrimaryBankProfDocId == primaryUploadedList[0].uid) {
                            primaryForm.setFields([
                                {
                                    name: 'primaryBankConfirmation',
                                    errors: ['Change bank confirmation document to continue']
                                }
                            ]);
                            return Promise.reject();
                        }
                        bankDetailDto.bankStatementDocId = toNumber(primaryUploadedList[0].uid)
                    }
                    bankDetailWrapperDto.primaryUpdated = true
                    bankDetailWrapperDto.primeryBankDetailDto = bankDetailDto
                } else {
                    let bankDetailDto: BankDetailDto = primaryAccData
                    bankDetailDto.bankAccountType = BANK_ACC_TYPE_PRIMARY
                    bankDetailDto.cin = props.cin
                    bankDetailDto.jobNumber = jobNumber

                    if (primaryUploadedList) {
                        bankDetailDto.bankStatementDocId = toNumber(primaryUploadedList[0].uid)
                    }
                    bankDetailWrapperDto.primaryUpdated = false
                    bankDetailWrapperDto.primeryBankDetailDto = bankDetailDto
                }
                return Promise.resolve();
            }).catch(() => {
                return Promise.reject();
            })

            if (isSetSecondaryAccDataFilledAlready) {
                secondaryAccPromise = secondaryForm.validateFields().then(() => {
                    if (validateAddressChanges(secondaryAccData, secondaryForm.getFieldsValue(), false)) {
                        let bankDetailDto: BankDetailDto = secondaryForm.getFieldsValue()
                        bankDetailDto.bankAccountType = BANK_ACC_TYPE_SECONDARY
                        bankDetailDto.cin = props.cin
                        bankDetailDto.jobNumber = jobNumber
                        if (secondaryUploaderList && secondaryUploaderList.length > 0) {
                            if (tempSecondaryBankDocId == secondaryUploaderList[0].uid) {
                                secondaryForm.setFields([
                                    {
                                        name: 'secondaryBankConfirmation',
                                        errors: ['Change bank confirmation document to continue']
                                    }
                                ]);
                                return Promise.reject();
                            }
                            bankDetailDto.bankStatementDocId = toNumber(secondaryUploaderList[0].uid)
                        }
                        bankDetailWrapperDto.correspondenceUpdated = true
                        bankDetailWrapperDto.correspondenceBankDetailDto = bankDetailDto

                    } else {
                        let bankDetailDto: BankDetailDto = secondaryAccData
                        bankDetailDto.bankAccountType = BANK_ACC_TYPE_SECONDARY
                        bankDetailDto.cin = props.cin
                        bankDetailDto.jobNumber = jobNumber
                        if (secondaryUploaderList) {
                            bankDetailDto.bankStatementDocId = toNumber(secondaryUploaderList[0].uid)
                        }
                        bankDetailWrapperDto.correspondenceUpdated = false
                        bankDetailWrapperDto.correspondenceBankDetailDto = bankDetailDto
                    }
                    return Promise.resolve();
                }).catch(() => {
                    return Promise.reject();
                })
            } else {
                if (validateAddressChanges(secondaryAccData, secondaryForm.getFieldsValue(), false)) {
                    //this set true to validate all required fields is system detect secondary account change where
                    //user not filled in onboarding process
                    setSecondaryAccDataFilledAlready(true)
                    //---

                    secondaryAccPromise = secondaryForm.validateFields().then(() => {
                        let bankDetailDto: BankDetailDto = secondaryForm.getFieldsValue()
                        bankDetailDto.bankAccountType = BANK_ACC_TYPE_SECONDARY
                        bankDetailDto.cin = props.cin
                        bankDetailDto.jobNumber = jobNumber
                        if (secondaryUploaderList && secondaryUploaderList.length > 0) {
                            bankDetailDto.bankStatementDocId = toNumber(secondaryUploaderList[0].uid)
                        } else {
                            secondaryForm.setFields([
                                {
                                    name: 'secondaryBankConfirmation',
                                    errors: ['Upload bank confirmation document to continue']
                                },
                            ]);
                            return Promise.reject();
                        }
                        bankDetailWrapperDto.correspondenceUpdated = true
                        bankDetailWrapperDto.correspondenceBankDetailDto = bankDetailDto
                    }).catch(() => {
                        return Promise.reject();
                    })

                } else {
                    let bankDetailDto = {
                        id: "",
                        bankId: "",
                        branchId: "",
                        accountNo: "",
                        accountHolderName: "",
                        bankAccountType: "",
                        branchName: "",
                        bankName: "",
                        cin: "",
                        recordStatus: null,
                    } as BankDetailDto
                    bankDetailDto.bankAccountType = BANK_ACC_TYPE_SECONDARY
                    bankDetailDto.cin = props.cin
                    bankDetailDto.jobNumber = jobNumber
                    if (undefined != secondaryUploaderList && secondaryUploaderList.length > 0) {
                        bankDetailDto.bankStatementDocId = toNumber(secondaryUploaderList[0].uid)
                    }
                    bankDetailWrapperDto.correspondenceUpdated = false
                    bankDetailWrapperDto.correspondenceBankDetailDto = bankDetailDto
                }
            }
            Promise.all([primaryAccPromise, secondaryAccPromise])
                .then(() => {
                    modal.confirm({
                        title: 'Confirm',
                        icon: <ExclamationCircleOutlined/>,
                        content: `Are you sure?, Do you want to update the bank detail?`,
                        okText: 'Yes',
                        cancelText: 'No',
                        className: 'confirm-dialog-box',
                        okButtonProps: {style: {background: '#FF7400'}},
                        onOk() {
                            customerChangeRequestService.submitCustomerBankDetailChangeRequest(bankDetailWrapperDto, props.cin).then((res) => {
                                message.success("Successfully submitted to authorization")
                                setBankDetailList(res.data.results.bankDetailDtoList)
                                setAbleToEdit(res.data.results.editable)
                                setLoading(false)
                            }, (reason) => {
                                setLoading(false)
                                ErrorHandler.handleError(reason);
                            })
                        },
                        onCancel() {
                            setLoading(false)
                        }
                    });

                })
                .catch(() => {

                    message.warning("Fill all required fields!");

                    setLoading(false);
                });

        } else {
            //this field set to false to remove triggered validations in secondary section
            // if (!isSetSecondaryAccDataFilledAlreadyTemp) {
            //     setSecondaryAccDataFilledAlready(false)
            // }
            secondaryForm.validateFields()
            primaryForm.validateFields()

            //--
            message.warning("No changes detected")
            setLoading(false)
        }

    }

    const onClickEdit = () => {
        setEditDisabled(!isEditDisabled)
        setPrimaryBankConfirmationChanged(false)
        setSecondaryBankConfirmationChanged(false)
        if (!isEditDisabled) {
            secondaryForm.resetFields()
            setSecondaryUploadedList(undefined)
            setFieldValues(bankDetailList)
        }
    }

    const validateBothAddressChanges = (currentPermanentAddressDto: BankDetailDto | undefined, currentCorrespondentAddressDto: BankDetailDto | undefined,
                                        fieldValuesPermanentAddr: BankDetailDto, fieldValuesCorresAddr: BankDetailDto) => {

        return validateAddressChanges(currentPermanentAddressDto, fieldValuesPermanentAddr, true) ||
            validateAddressChanges(currentCorrespondentAddressDto, fieldValuesCorresAddr, false)
    }

    const validateAddressChanges = (addressDto: BankDetailDto | undefined, fieldValues: BankDetailDto, isPrimary: boolean): boolean => {
        let validatedtBankDetail: BankDetailDto = addressDto ? addressDto : {
            accountNo: "",
            accountHolderName: "",
            branchId: "",
            bankId: "",
        } as BankDetailDto

        if (validateFieldValues(validatedtBankDetail.accountNo) != validateFieldValues(fieldValues.accountNo)) {
            return true;
        } else if (validateFieldValues(validatedtBankDetail.accountHolderName) != validateFieldValues(fieldValues.accountHolderName)) {
            return true;
        } else if (validateFieldValues(validatedtBankDetail.branchId) != validateFieldValues(fieldValues.branchId)) {
            return true;
        } else if (validateFieldValues(validatedtBankDetail.bankId) != validateFieldValues(fieldValues.bankId)) {
            return true;
        }

        if (isPrimary) {
            if (isPrimaryBankConfirmationChanged) {
                return true
            }
        } else {
            if (isSecondaryBankConfirmationChanged) {
                return true
            }
        }
        return false;
    }
    const validateFieldValues = (value: any) => {
        return value ?? ""
    }

    const beforeUploadPrimaryBankConfirmation = (file: any) => {
        setPrimaryBankConfirmationChanged(true)
        return validateDocument(file, DOCUMENT_TYPES.PBCL_TEMP, ALLOWED_IMAGE_TYPES);
    };
    const beforeUploadSecondaryBankConfirmation = (file: any) => {
        setSecondaryBankConfirmationChanged(true)
        return validateDocument(file, DOCUMENT_TYPES.SBCL_TEMP, ALLOWED_IMAGE_TYPES);
    };

    const validateDocument = (file: any, type: number, allowedDocTypes: string[]) => {
        setLoading(true)
        let indexOf = allowedDocTypes.indexOf(file.type);
        if (indexOf < 0) {

            message.error(JSON.stringify(allowedDocTypes) === JSON.stringify(ALLOWED_IMAGE_TYPES) ? MSG_ALLOWED_IMAGE_TYPES_ERROR : MSG_ALLOWED_DOCUMENT_TYPES_ERROR);
            setLoading(false)
            return Upload.LIST_IGNORE;
        }
        const isLt2M = file.size / 1024 / 1024 <= uploadFileSize;
        if (!isLt2M) {
            message.error(`Document must smaller than ${uploadFileSize}MB!`);
            setLoading(false)
            return Upload.LIST_IGNORE;
        }

        const formData = new FormData();
        formData.append("files", file);

        formData.append("jobNo", jobNumber);
        formData.append("documentTypeId", JSON.stringify(type));

        documentService.uploadDocument(formData).then(res => {
            if (res.data !== null) {
                let results = res.data.results;
                let uploadDocumentDetailDto: UploadedDocumentDetailDto = results.uploadDocumentDetailDtoList[0];
                createUploadedDocuments(uploadDocumentDetailDto, uploadDocumentDetailDto.documentTypeId)
                // setUploadDocumentDetailId(uploadDocumentDetailDto.uploadDocumentDetailId)
                setLoading(false)
            } else {
                setLoading(false)
                message.error(MSG_FAILED_TO_UPLOAD_DOCUMENTS_ERROR).then();
            }
        }, (reason) => {
            setLoading(false)
            ErrorHandler.handleError(reason);
        })
        return false;
    };

    const createUploadedDocuments = (uploadDocumentDetailDtoList: UploadedDocumentDetailDto, documentTypeId: number) => {
        setLoading(false)
        let defaultFileList;
        if (undefined != uploadDocumentDetailDtoList) {
            defaultFileList =
                [{
                    uid: uploadDocumentDetailDtoList.uploadDocumentDetailId.toString(),
                    name: uploadDocumentDetailDtoList.originalDocumentName,
                    thumbUrl: uploadDocumentDetailDtoList.thumbB64,
                    url: uploadDocumentDetailDtoList.thumbDocumentPath,
                    documentTypeId: documentTypeId
                }]
        } else {
            defaultFileList = undefined;
        }

        if (documentTypeId == DOCUMENT_TYPES.PBCL_TEMP || documentTypeId == DOCUMENT_TYPES.PBCL) {
            setPrimaryUploadedList(defaultFileList)
            primaryForm.setFieldsValue({primaryBankConfirmation: defaultFileList})
        } else if (documentTypeId == DOCUMENT_TYPES.SBCL_TEMP || documentTypeId == DOCUMENT_TYPES.SBCL) {
            setSecondaryUploadedList(defaultFileList)
            secondaryForm.setFieldsValue({secondaryBankConfirmation: defaultFileList})
        }
    };
    const onRemove = (docId: number) => {
        if (docId != 0) {
            setLoading(true)
            if (docId == DOCUMENT_TYPES.PBCL) {
                setPrimaryUploadedList([])
                setLoading(false)
                setPrimaryBankConfirmationChanged(true)
                primaryForm.setFieldsValue({primaryBankConfirmation: []})

            } else if (docId == DOCUMENT_TYPES.SBCL) {
                setSecondaryUploadedList([])
                setSecondaryBankConfirmationChanged(true)
                secondaryForm.setFieldsValue({secondaryBankConfirmation: []})

                setLoading(false)
            } else {
                documentService.deleteDocumentById(
                    DOCUMENT_TYPES.PBCL_TEMP === docId ? primaryUploadedList[0].uid : secondaryUploaderList[0].uid).then(res => {
                    if (res.data !== null) {
                        setLoading(false)
                        if (DOCUMENT_TYPES.PBCL_TEMP === docId) {
                            setPrimaryUploadedList([])
                            primaryForm.setFieldsValue({primaryBankConfirmation: []})
                            setPrimaryBankConfirmationChanged(true)
                        } else {
                            setSecondaryUploadedList([])
                            secondaryForm.setFieldsValue({secondaryBankConfirmation: []})
                            setSecondaryBankConfirmationChanged(true)
                        }
                    } else {
                        message.error(MSG_FAILED_TO_DELETE_DOCUMENTS_ERROR).then();
                        setLoading(false)
                    }
                }, (reason) => {
                    ErrorHandler.handleError(reason);
                    setLoading(false)
                })
            }


            return true;
        }

    };
    const normFile = (e: { fileList: any; }) => {
        if (Array.isArray(e)) {
            return e;
        }
        return e && e.fileList;
    };
    const onPreview = (documentId: string, docTypeName: string) => {
        setLoading(true)
        documentService.viewOriginalDocument(documentId).then(res => {
            if (res.data !== null) {
                setPreviewOpen(true)
                setIsModalOpen(false)
                setPreviewTitle(docTypeName);
                setDocURL(res.data.results)
                setDocType(checkDocumentContentType(res.data.results))
                setLoading(false)
            } else {
                message.error(MSG_FAILED_TO_FETCH_DOCUMENTS_ERROR).then();
                setLoading(false)
            }
        }, (reason) => {
            setLoading(false)
            ErrorHandler.handleError(reason);
        })
        return true;
    };
    const checkDocumentContentType = (base64: string): PREVIEW_DOC_TYPES => {

        if (base64.includes("image/png") || base64.includes("image/jpeg") || base64.includes("image/jpg")) {
            return PREVIEW_DOC_TYPES.IMAGE;
        } else {
            return PREVIEW_DOC_TYPES.PDF;
        }

    };
    const handlePreviewCancel = () => {
        setPreviewOpen(false);
    };
    const download = (val: string, docName: string) => {
        let a = document.createElement('a');
        a.href = val;
        a.download = docName;
        a.click();
    }
    const handleCheckBoxChange = (value: boolean) => {
        setSecondaryAccDataFilledAlready(value)

        if (!value) {
            secondaryForm.validateFields()
            secondaryForm.resetFields()
            setSecondaryUploadedList([])
            setBranchListSecondary([])
        }

    }
    return (
        <Spin spinning={isLoading}>

            <Row gutter={[24, 12]}>
                {
                    !isAbleToEdit ?
                        <Col span={24} style={{marginBottom: 8}}>
                            <Alert
                                message="A new request cannot be processed because a request has already been raised."
                                type="warning" showIcon/>
                        </Col> :
                        <Col span={24} className={'request-screen-edit-btn-position'}>
                            <Space style={{float: 'right'}}>
                                <Button
                                    style={{
                                        width: 84,
                                    }}
                                onClick={onClickEdit}>
                                    Edit
                                </Button>
                            </Space>
                        </Col>
                }
                <Col span={12}>
                    <Card title="Primary Bank Account Details">
                        <Form
                            className='form-input'
                            layout={"vertical"}
                            initialValues={{remember: true}}
                            form={primaryForm}
                            disabled={!isAbleToEdit || isEditDisabled}
                        >
                            <div style={{display: "none"}}>
                                <Form.Item
                                    label=""
                                    name={"id"}>
                                    <Input/>
                                </Form.Item>
                            </div>
                            <div style={{display: "none"}}>
                                <Form.Item
                                    label=""
                                    name={"recordStatus"}>
                                    <Input/>
                                </Form.Item>
                            </div>
                            <Row gutter={[32, 0]}>
                                <Col xxl={12} xl={24} lg={24} md={24} sm={24} xs={24}>
                                    <Form.Item
                                        label="Name of the Bank"
                                        name={"bankId"}
                                        rules={[{
                                            required: true,
                                            message: 'Please select bank name'
                                        }]}>
                                        <Select placement='bottomLeft' onChange={onChangeBank}
                                                placeholder={"Select bank name"}
                                                showSearch
                                                optionFilterProp="children"
                                                filterOption={(input: any, option: {
                                                    label: any;
                                                }) => (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())}
                                                getPopupContainer={(trigger: { parentNode: any; }) => trigger.parentNode}
                                                options={bankList}
                                        />

                                    </Form.Item>
                                </Col>
                                <Col xxl={12} xl={24} lg={24} md={24} sm={24} xs={24}>
                                    <Form.Item
                                        label="Branch"
                                        name={"branchId"}
                                        rules={[{
                                            required: true,
                                            message: 'Please select branch'
                                        }]}>
                                        <Select placement='bottomLeft' defaultSelected={""}
                                                placeholder={"Select branch"}
                                                showSearch
                                                optionFilterProp="children"
                                                filterOption={(input: any, option: {
                                                    label: any;
                                                }) => (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())}
                                                getPopupContainer={(trigger: { parentNode: any; }) => trigger.parentNode}
                                                options={branchListPrimary}
                                        />

                                    </Form.Item>
                                </Col>
                                <Col xxl={12} xl={24} lg={24} md={24} sm={24} xs={24}>
                                    <Form.Item
                                        label="Account Number"
                                        name={"accountNo"}
                                        onKeyPress={Validation.isNumberWithoutDot}
                                        rules={[
                                            {required: true, message: 'Please enter account number'},
                                            {
                                                max: 30,
                                                message: 'The maximum length is 30 numbers'
                                            }
                                        ]}>
                                        <Input autoComplete="off" placeholder={"Enter account number"}/>
                                    </Form.Item>
                                </Col>
                                <Col xxl={12} xl={24} lg={24} md={24} sm={24} xs={24}>
                                    <Form.Item
                                        label="Account Holder`s Name"
                                        name={"accountHolderName"}
                                        onKeyPress={Validation.onlyAlphabeticWithSpace}
                                        rules={[{
                                            required: true,
                                            message: 'Please enter account holder`s name'
                                        },
                                            {
                                                max: 50,
                                                message: 'The maximum length is 50 characters'
                                            },
                                            {
                                                pattern: ACCOUNT_NAME_VALIDATION,
                                                message: 'Special characters and numbers are not allowed'
                                            }
                                        ]}>
                                        <Input autoComplete="off" type="text" placeholder={"Enter account holder`s name"}/>
                                    </Form.Item>
                                </Col>

                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                    <Form.Item
                                        label="Primary Bank Confirmation"
                                        name={"primaryBankConfirmation"}
                                        initialValue={primaryUploadedList && primaryUploadedList?.length > 0 ? [primaryUploadedList] : undefined}
                                        getValueFromEvent={normFile}

                                        rules={[{
                                            required: true,
                                            message: 'Please upload your bank confirmation'
                                        }]}
                                    >
                                        <Upload {...configs}
                                                className='upload_comp'
                                                accept={ALLOWED_IMAGE_TYPE_EXTENSION}
                                                listType="picture"
                                                onPreview={(e: any) => {
                                                    onPreview(primaryUploadedList ? primaryUploadedList[0].uid : '',
                                                        primaryUploadedList ? primaryUploadedList[0].name : '')
                                                }}
                                                onRemove={(e: any) => onRemove(primaryUploadedList ? primaryUploadedList[0].documentTypeId : 0)}
                                                fileList={primaryUploadedList && primaryUploadedList?.length > 0 ? primaryUploadedList : undefined}
                                                beforeUpload={beforeUploadPrimaryBankConfirmation}
                                        >
                                            {(undefined != primaryUploadedList ? primaryUploadedList.length : [].length) < 1 &&
                                            <Button>
                                                <div className='upload-btn-div'>
                                                    <div className="upload-icon-div">
                                                        <PlusOutlined
                                                            style={{fontSize: 20, color: '#757575'}}/>
                                                    </div>
                                                    <div className="upload-btn-text-div">
                                                                <span>
                                                                    Upload the primary bank confirmation document {ALLOWED_IMAGE_TYPES_TEXT}
                                                                </span>
                                                    </div>
                                                </div>
                                            </Button>
                                            }
                                        </Upload>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                    </Card>
                </Col>
                <Col span={12}>

                    <Card title={
                        <span>
                            Secondary Bank Account Details
                            <Checkbox style={{marginLeft: 10}}
                                      onChange={() => handleCheckBoxChange(!isSetSecondaryAccDataFilledAlready)}
                                      disabled={isSetSecondaryAccDataFilledAlreadyTemp}
                                      checked={isSetSecondaryAccDataFilledAlready}>
                            </Checkbox>
                        </span>
                    }>

                        <Form
                            className='form-input'
                            layout={"vertical"}
                            initialValues={{remember: true}}
                            form={secondaryForm}
                            disabled={!isAbleToEdit || isEditDisabled}
                        >
                            <div style={{display: "none"}}>
                                <Form.Item
                                    label=""
                                    name={"id"}>
                                    <Input/>
                                </Form.Item>
                            </div>
                            <div style={{display: "none"}}>
                                <Form.Item
                                    label=""
                                    name={"recordStatus"}>
                                    <Input/>
                                </Form.Item>
                            </div>

                            <Row gutter={[32, 0]}>
                                <Col xxl={12} xl={24} lg={24} md={24} sm={24} xs={24}>
                                    <Form.Item
                                        label="Name of the Bank"
                                        name={"bankId"}
                                        rules={[{
                                            required: isSetSecondaryAccDataFilledAlready,
                                            message: 'Please select bank name'
                                        }]}>
                                        <Select placement='bottomLeft' onChange={onChangeBankSec}
                                                placeholder={"Select bank name"}
                                                showSearch
                                                optionFilterProp="children"
                                                filterOption={(input: any, option: {
                                                    label: any;
                                                }) => (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())}
                                                getPopupContainer={(trigger: { parentNode: any; }) => trigger.parentNode}
                                                options={bankList}
                                        />

                                    </Form.Item>
                                </Col>
                                <Col xxl={12} xl={24} lg={24} md={24} sm={24} xs={24}>
                                    <Form.Item
                                        label="Branch"
                                        name={"branchId"}
                                        rules={[{
                                            required: isSetSecondaryAccDataFilledAlready,
                                            message: 'Please select branch'
                                        }]}>
                                        <Select placement='bottomLeft' defaultSelected={""}
                                                placeholder={"Select branch"}
                                                showSearch
                                                optionFilterProp="children"
                                                filterOption={(input: any, option: {
                                                    label: any;
                                                }) => (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())}
                                                getPopupContainer={(trigger: { parentNode: any; }) => trigger.parentNode}
                                                options={branchListSec}
                                        />

                                    </Form.Item>
                                </Col>
                                <Col xxl={12} xl={24} lg={24} md={24} sm={24} xs={24}>
                                    <Form.Item
                                        label="Account Number"
                                        name={"accountNo"}
                                        onKeyPress={Validation.isNumberWithoutDot}
                                        rules={[
                                            {
                                                required: isSetSecondaryAccDataFilledAlready,
                                                message: 'Please enter account number'
                                            },
                                            {
                                                max: 30,
                                                message: 'The maximum length is 30 numbers'
                                            }
                                        ]}>
                                        <Input autoComplete="off" placeholder={"Enter account number"}/>
                                    </Form.Item>
                                </Col>
                                <Col xxl={12} xl={24} lg={24} md={24} sm={24} xs={24}>
                                    <Form.Item
                                        label="Account Holder`s Name"
                                        name={"accountHolderName"}
                                        onKeyPress={Validation.onlyAlphabeticWithSpace}
                                        rules={[{
                                            required: isSetSecondaryAccDataFilledAlready,
                                            message: 'Please enter account holder`s name'
                                        },
                                            {
                                                max: 50,
                                                message: 'The maximum length is 50 characters'
                                            },
                                            {
                                                pattern: ACCOUNT_NAME_VALIDATION,
                                                message: 'Special characters and numbers are not allowed'
                                            }
                                        ]}>
                                        <Input autoComplete="off" type="text" placeholder={"Enter account holder`s name"}/>
                                    </Form.Item>
                                </Col>

                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                    <Form.Item
                                        label="Secondary Bank Confirmation"
                                        name={"secondaryBankConfirmation"}
                                        getValueFromEvent={normFile}
                                        initialValue={secondaryUploaderList && secondaryUploaderList?.length > 0 ? [secondaryUploaderList] : undefined}
                                        rules={[{
                                            required: isSetSecondaryAccDataFilledAlready,
                                            message: 'Please upload your bank confirmation'
                                        }]}
                                    >
                                        <Upload {...configs}
                                                className='upload_comp'
                                                accept={ALLOWED_IMAGE_TYPE_EXTENSION}
                                                listType="picture"
                                                onPreview={(e: any) => {
                                                    onPreview(secondaryUploaderList ? secondaryUploaderList[0].uid : '',
                                                        secondaryUploaderList ? secondaryUploaderList[0].name : '')
                                                }}
                                                onRemove={(e: any) => onRemove(secondaryUploaderList ? secondaryUploaderList[0].documentTypeId : 0)}
                                                fileList={secondaryUploaderList && secondaryUploaderList?.length > 0 ? secondaryUploaderList : undefined}
                                                beforeUpload={beforeUploadSecondaryBankConfirmation}
                                        >
                                            {(undefined != secondaryUploaderList ? secondaryUploaderList.length : [].length) < 1 &&
                                            <Button>
                                                <div className='upload-btn-div'>
                                                    <div className="upload-icon-div">
                                                        <PlusOutlined
                                                            style={{fontSize: 20, color: '#757575'}}/>
                                                    </div>
                                                    <div className="upload-btn-text-div">
                                                                <span>
                                                                    Upload the secondary bank confirmation document {ALLOWED_IMAGE_TYPES_TEXT}
                                                                </span>
                                                    </div>
                                                </div>
                                            </Button>
                                            }
                                        </Upload>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                    </Card>
                </Col>
                <Col span={24}>
                    <Divider style={{marginBottom: 12}}></Divider>
                </Col>
                <Col span={24}>
                    <Space style={{float: 'right'}}>
                        <Button size={'large'} disabled={!isAbleToEdit || isEditDisabled}
                                style={{
                                    width: 120,
                                    background: "#FF7400",
                                    color: "white",
                                }} onClick={onClickSubmit}>Submit</Button>
                    </Space>
                </Col>
            </Row>
            <Modal
                className={docType == PREVIEW_DOC_TYPES.PDF ? "modal-custom-bg" : "image-view-modal"}
                open={previewOpen}
                centered
                title={previewTitle}
                onCancel={handlePreviewCancel}
                destroyOnClose={true}
                width={docType == PREVIEW_DOC_TYPES.PDF ? 800 : 600}
                footer={[
                    <Button type="primary" icon={<DownloadOutlined/>} style={{background: '#FF7400', height: 40}}
                            htmlType="submit" onClick={() => download(docURL, previewTitle)}>
                        Download
                    </Button>]}>
                <PreviewModalComp docURL={docURL}/>
            </Modal>
        </Spin>
    )

}
export default BankDetailsChangeRequestComp;

